import { Heart } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { useFavorites } from '@/hooks/useFavorites';

/**
 * Serduszko nad zdjęciem — karta w wynikach i dymek na mapie rysują DOKŁADNIE to samo.
 *
 * Stan bierze się z `useFavorites`, a nie z lokalnego `useState` przy każdym zdjęciu. To
 * jest cała zmiana merytoryczna: dotąd każda karta miała własne serduszko, które nic nie
 * pamiętało — po przewinięciu listy stan znikał, a ta sama oferta na mapie i w wynikach
 * pokazywała dwie różne prawdy.
 *
 * `e.preventDefault()` i `stopPropagation` są konieczne, bo serduszko leży NA odnośniku
 * obejmującym kartę: bez nich dotknięcie polubienia otwiera ofertę.
 */
export function FavoriteButton({
  offerId,
  className,
  rozmiar = 'h-6 w-6',
}: {
  offerId: string;
  className?: string;
  rozmiar?: string;
}) {
  const { t } = useTranslation();
  const { czyUlubiona, przelaczUlubiona } = useFavorites();
  const ulubiona = czyUlubiona(offerId);
  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        przelaczUlubiona(offerId);
      }}
      aria-pressed={ulubiona}
      aria-label={t(ulubiona ? 'search.card.unfavorite' : 'search.card.favorite')}
      className={cn('strefa-dotyku rounded-full p-1.5 transition-transform active:scale-90', className)}
    >
      <Heart
        className={cn(
          rozmiar,
          'stroke-[2.25] drop-shadow-md transition-colors',
          ulubiona ? 'fill-favorite text-favorite' : 'fill-black/30 text-white',
        )}
      />
    </button>
  );
}

export default FavoriteButton;
